// Page titles
const pageTitles = {
  ACCOUNT_PAGE: `Let's get started`,
  NAME_PAGE: 'Hello there!',
  EMAIL_PAGE: 'Your email address',
  VERIFY_EMAIL_PAGE: 'Verify your email',
  DOB_PAGE: 'Your date of birth',
  PHONE_PAGE: 'Your mobile phone',
  VERIFY_PHONE_PAGE: 'Verify your number',
  ADDRESS_PAGE: 'Your home address',
  PASSWORD_PAGE: 'Create password',
  SSN_PAGE: 'Verify your identity',
  ACTIVITY_PAGE: 'A few more details',
  TERMS_PAGE: 'Terms of Services',
  DECLINE_PAGE: "We're sorry!",
  ENABLE_CAMERA_ACCESS_PAGE: 'Enable camera access',
  ALREADY_HAS_ACTIVE_ACCOUNT_PAGE: 'You already have a Chime account',
  PREFILL_CONFIRMATION_PAGE: 'Does this look right?',
};

export default pageTitles;
